import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledTextareaSection = styled.div<{ $isBigIcon: boolean }>`
  margin-top: 25px;
  direction: rtl;
  padding: 0 5px;

  .header {
    display: flex;
    align-items: ${({ $isBigIcon }) => ($isBigIcon ? "baseline" : "center")};
    gap: 11px;
    margin-bottom: 14px;

    .title {
      font-size: 16px;
      color: ${colors.darkBlue};
      text-align: right;
      font-weight: 400;
      line-height: 16px;
      margin: 0;
    }
  }

  .textarea-container {
    position: relative;
    display: flex;
    align-items: flex-start;

    .edit-button {
      position: absolute;
      left: 12px;
      top: 12px;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 1;
      border-radius: 4px;
      color: ${colors.darkBlue};
      padding: 4px;
      transition: all 0.2s ease;

      img {
        width: 15px;
        height: 15px;
      }

      &:hover {
        background-color: ${colors.lightBlueGray};
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }
    }

    .button-container {
      position: absolute;
      left: 12px;
      top: 12px;
      display: flex;
      gap: 0.5rem;
      z-index: 1;
    }

    .save-button,
    .cancel-button {
      background: none;
      border: none;
      cursor: pointer;
      border-radius: 6px;
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      color: inherit;

      &:hover {
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }
    }

    .save-button {
      color: ${colors.green};

      &:hover {
        background-color: ${colors.green}15;
        color: ${colors.green};
      }
    }

    .cancel-button {
      color: ${colors.red};

      &:hover {
        background-color: ${colors.red}15;
        color: ${colors.red};
      }
    }

    .textarea {
      flex: 1;
      border-radius: 8px;
      font-size: 12px;
      background: ${colors.lightBlueGrayBackground};
      font-family: "Noto Sans Hebrew", sans-serif;
      padding: 11px 16px 11px 40px;
      min-height: 97px;
      resize: none;
      direction: rtl;
      text-align: right;
      border: none;

      &:not(.read-only) {
        border: 1px solid ${colors.blueGrayAlpha80};
        padding: 11px 16px 11px 80px;

        &:focus {
          outline: none;
          border-color: ${colors.blueGrayAlpha80};
        }
      }

      &.read-only:focus-within {
        outline: none;
        border: none;
      }

      &::placeholder {
        color: ${colors.blueGray};
        text-align: right;
        font-size: 10px;
      }
    }
  }
`;
